import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider } from "antd";
import { getMenuGroups } from "../../ui/menuConfig";
import "../../../assets/styles/MenuDashboard.css";

const { Text, Title } = Typography;

function MenuDashboard({ onClick }) {
  const navigate = useNavigate();

  const handleMenuClick = (item) => {
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header
    navigate(item.path);
  };
  // โครงสร้างเมนูแบบแบ่งกลุ่ม (Grouped Structure) ใช้ร่วมกับ Sidenav
  const menuGroups = getMenuGroups();

  return (
    <div className="dashboard-wrapper" style={{ padding: "24px" }}>
      {menuGroups.map(
        (group, gIndex) =>
          group.show && (
            <div
              key={gIndex}
              className="menu-group-section"
              style={{ marginBottom: "32px" }}
            >
              {/* Divider หมวดหมู่หลัก (ตรงกลาง) */}
              <Divider orientation="center">
                <Title
                  level={4}
                  className="group-title-gold"
                  style={{ margin: 0 }}
                >
                  {group.groupTitle}
                </Title>
              </Divider>

              {/* ตรวจสอบว่ามี Sub-groups หรือไม่ */}
              {group.subGroups ? (
                // กรณีมี Sub-groups (การเงิน, บัญชี)
                group.subGroups.map((sub, sIndex) => (
                  <div key={sIndex} className="sub-group-container">
                    {/* Divider หมวดหมู่ย่อย (ชิดซ้าย) */}
                    <Divider
                      orientation="center"
                      style={{ borderColor: "#f0f0f0", margin: "18px 0" }}
                    >
                      <Text
                        strong
                        style={{ color: "#8c8c8c", fontSize: "18px" }}
                      >
                        {sub.subTitle}
                      </Text>
                    </Divider>

                    <Row gutter={[16, 16]} justify="center">
                      {sub.items.map(
                        (item, index) =>
                          item.show && (
                            <Col
                              xs={24}
                              sm={12}
                              md={8}
                              lg={6}
                              xl={4}
                              key={index}
                            >
                              <div
                                className="menu-card"
                                onClick={() => handleMenuClick(item)}
                                style={{ alignText: "center" }}
                              >
                                <div className="icon-wrapper">{item.icon}</div>
                                <Text className="menu-text-gold">
                                  {item.label}
                                </Text>
                              </div>
                            </Col>
                          ),
                      )}
                    </Row>
                  </div>
                ))
              ) : (
                // กรณีไม่มี Sub-groups ให้วาดเมนูตามปกติ
                <Row gutter={[16, 16]} justify="center">
                  {group.items.map(
                    (item, index) =>
                      item.show && (
                        <Col xs={12} sm={8} md={6} lg={4} key={index}>
                          <div
                            className="menu-card"
                            onClick={() => handleMenuClick(item)}
                          >
                            <div className="icon-wrapper">{item.icon}</div>
                            <Text className="menu-text-gold">{item.label}</Text>
                          </div>
                        </Col>
                      ),
                  )}
                </Row>
              )}
            </div>
          ),
      )}
    </div>
  );
}

export default MenuDashboard;
